/* Latori custom js adjustments */

let terms_conditions_checkbox = document.querySelector(".terms_conditions-wrapper input");
let data_privacy_checkbox = document.querySelector(".data_privacy-wrapper input");

if (terms_conditions_checkbox) {
  terms_conditions_checkbox.addEventListener("click", () => {
    if(terms_conditions_checkbox.checked === true && data_privacy_checkbox.checked === true) {
      document.querySelector(".cart-btn #cartCheckout").removeAttribute("disabled");
    }
    if (data_privacy_checkbox.checked === false) {
      document.querySelector(".cart-btn #cartCheckout").setAttribute("disabled", "");
    }
  })
}

if (data_privacy_checkbox) {
  data_privacy_checkbox.addEventListener("click", () => {
    if(data_privacy_checkbox.checked === true && terms_conditions_checkbox.checked === true) {
      document.querySelector(".cart-btn #cartCheckout").removeAttribute("disabled");
    }
    if (data_privacy_checkbox.checked === false) {
      document.querySelector(".cart-btn #cartCheckout").setAttribute("disabled", "");
    }
  })
}

